import { Autocomplete, Box, Paper, TextField, ThemeProvider, createTheme, useTheme } from '@mui/material';
import { DiscoverMovieReleaseType } from '@tmdb-graphql-api/schema/types';
import { type FormikErrors } from 'formik';
import { type MovieFormikValues, type NumberOption } from '../types.ts';

export type ReleaseTypeMultiSelectDropdownProps = {
  ariaLabelledBy: string;
  name: string;
  setFieldValue: (
    field: string,
    value: any, // eslint-disable-line @typescript-eslint/no-explicit-any
    shouldValidate?: boolean,
  ) => Promise<FormikErrors<MovieFormikValues>> | Promise<void>;
  value: NumberOption[];
};

export const releaseTypeOptions = [
  {
    id: DiscoverMovieReleaseType.Digital,
    name: 'Digital',
  },
  {
    id: DiscoverMovieReleaseType.Physical,
    name: 'Physical',
  },
  {
    id: DiscoverMovieReleaseType.Premier,
    name: 'Premier',
  },
  {
    id: DiscoverMovieReleaseType.Theatrical,
    name: 'Theatrical',
  },
  {
    id: DiscoverMovieReleaseType.TheatricalLimited,
    name: 'Theatrical (limited)',
  },
  {
    id: DiscoverMovieReleaseType.Tv,
    name: 'Tv',
  },
];

export const ReleaseTypeMultiSelectDropdown = ({
  ariaLabelledBy,
  name,
  setFieldValue,
  value,
}: ReleaseTypeMultiSelectDropdownProps) => {
  const theme = useTheme();

  return (
    <ThemeProvider theme={createTheme({ ...theme, palette: { mode: 'dark' } })}>
      <Autocomplete
        aria-labelledby={ariaLabelledBy}
        autoComplete
        clearIcon=""
        filterSelectedOptions
        getOptionLabel={option => option.name}
        includeInputInList
        multiple
        noOptionsText=""
        onChange={(_e, option) => {
          void setFieldValue(name, option);
        }}
        options={releaseTypeOptions}
        renderInput={params => <TextField {...params} fullWidth hiddenLabel placeholder="Enter name" />}
        renderOption={(props, renderOpts) => (
          <Box component="li" {...props} key={renderOpts.id}>
            {renderOpts.name}
          </Box>
        )}
        slots={{
          paper: params => <Paper {...params} sx={{ backgroundColor: '#222' }} />,
        }}
        value={value}
      />
    </ThemeProvider>
  );
};
